(() => {
  function initCartPage() {
    const cartPage = document.querySelector('.cart-page');
    if (!cartPage) return;

    const cartCore = window.HohoCartCore;
    if (!cartCore) return;

    if (window.__hohoCartPageBound) return;
    window.__hohoCartPageBound = true;

    const CART_SECTION_URL = `${cartCore.root}cart?section_id=main-cart-page`;

    let stockNoteTimer = null;
    let isRefreshing = false;

    function getCartPageRoot() {
      return document.querySelector('.cart-page');
    }

    function getSummary() {
      return document.querySelector('.cart-summary');
    }

    function setSummaryLoading(isLoading) {
      const summary = getSummary();
      if (!summary) return;
      summary.classList.toggle('is-updating', Boolean(isLoading));
    }

    function setLineLoading(line, isLoading) {
      const row = document.querySelector(`.cart-line[data-cart-line="${line}"]`);
      if (!row) return;
      row.classList.toggle('is-updating', Boolean(isLoading));
    }

    function updatePlusButtonState(row) {
      if (!row) return;

      const input = row.querySelector('[data-cart-qty-input]');
      const plusButton = row.querySelector('[data-cart-qty-increase]');
      const maxQtyRaw = row.getAttribute('data-max-qty');

      if (!input || !plusButton) return;

      if (!maxQtyRaw) {
        plusButton.disabled = false;
        return;
      }

      const currentQty = Number(input.value) || 0;
      const maxQty = Number(maxQtyRaw) || 0;

      plusButton.disabled = currentQty >= maxQty;
    }

    function updateAllPlusButtonStates() {
      document.querySelectorAll('.cart-line').forEach((row) => {
        updatePlusButtonState(row);
      });
    }

    function showStockNote(row, message = 'Max stock reached') {
      const note = row?.querySelector('[data-cart-stock-note]');
      if (!note) return;

      note.textContent = message;
      note.hidden = false;
      note.classList.add('is-visible');

      clearTimeout(stockNoteTimer);
      stockNoteTimer = window.setTimeout(() => {
        note.classList.remove('is-visible');
        window.setTimeout(() => {
          note.hidden = true;
        }, 180);
      }, 1600);
    }

    async function fetchCartSection() {
      const response = await fetch(CART_SECTION_URL, {
        headers: {
          Accept: 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error('Unable to refresh cart page');
      }

      return response.text();
    }

    async function refreshCartPage() {
      if (isRefreshing) return;

      isRefreshing = true;

      try {
        const html = await fetchCartSection();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const nextCartPage = doc.querySelector('.cart-page');
        const currentCartPage = getCartPageRoot();

        if (!nextCartPage || !currentCartPage) {
          throw new Error('Unable to replace cart page');
        }

        currentCartPage.replaceWith(nextCartPage);
        document.body.classList.remove('modal-open');
        document.dispatchEvent(new CustomEvent('cart-page:replaced'));
      } catch (error) {
        console.error(error);
        window.location.reload();
      } finally {
        isRefreshing = false;
      }
    }

    async function changeLine(line, quantity) {
      setLineLoading(line, true);
      setSummaryLoading(true);

      try {
        await cartCore.changeLine(line, quantity);
        await refreshCartPage();
      } catch (error) {
        console.error(error);
        setLineLoading(line, false);
        setSummaryLoading(false);
      }
    }

    document.addEventListener('click', async (event) => {
      const currentCartPage = getCartPageRoot();
      if (!currentCartPage) return;

      const decreaseButton = event.target.closest('[data-cart-qty-decrease]');
      if (decreaseButton && currentCartPage.contains(decreaseButton)) {
        const row = decreaseButton.closest('.cart-line');
        const line = Number(row?.getAttribute('data-cart-line'));
        const qtyInput = row?.querySelector('[data-cart-qty-input]');
        const current = Number(qtyInput?.value) || 0;
        const next = Math.max(0, current - 1);

        if (line) {
          event.preventDefault();
          await changeLine(line, next);
        }
        return;
      }

      const increaseButton = event.target.closest('[data-cart-qty-increase]');
      if (increaseButton && currentCartPage.contains(increaseButton)) {
        const row = increaseButton.closest('.cart-line');
        const line = Number(row?.getAttribute('data-cart-line'));
        const qtyInput = row?.querySelector('[data-cart-qty-input]');
        const maxQtyRaw = row?.getAttribute('data-max-qty');
        const current = Number(qtyInput?.value) || 0;

        if (maxQtyRaw) {
          const maxQty = Number(maxQtyRaw) || 0;
          if (current >= maxQty) {
            updatePlusButtonState(row);
            showStockNote(row);
            return;
          }
        }

        if (line) {
          event.preventDefault();
          await changeLine(line, current + 1);
        }
        return;
      }

      const removeButton = event.target.closest('[data-cart-remove]');
      if (removeButton && currentCartPage.contains(removeButton)) {
        const row = removeButton.closest('.cart-line');
        const line = Number(row?.getAttribute('data-cart-line'));

        if (line) {
          event.preventDefault();
          await changeLine(line, 0);
        }
      }
    });

    document.addEventListener('change', async (event) => {
      const qtyInput = event.target.closest('[data-cart-qty-input]');
      const currentCartPage = getCartPageRoot();

      if (!qtyInput || !currentCartPage || !currentCartPage.contains(qtyInput)) return;

      const row = qtyInput.closest('.cart-line');
      const line = Number(row?.getAttribute('data-cart-line'));
      const maxQtyRaw = row?.getAttribute('data-max-qty');

      let next = Math.max(0, Number(qtyInput.value) || 0);

      if (maxQtyRaw) {
        const maxQty = Number(maxQtyRaw) || 0;
        if (next > maxQty) {
          next = maxQty;
          qtyInput.value = String(maxQty);
          showStockNote(row);
        }
      }

      updatePlusButtonState(row);

      if (line) {
        await changeLine(line, next);
      }
    });

    document.addEventListener('cart-page:replaced', () => {
      updateAllPlusButtonStates();
    });

    updateAllPlusButtonStates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPage, { once: true });
  } else {
    initCartPage();
  }
})();
(() => {
  const MAX_OPTIONS = 2;
  const CUTOFF_HOURS = 48;

  const PICKUP_SCHEDULES = [
    {
      key: 'metrotown-tuesday',
      weekday: 2,
      location: 'Metrotown Station',
      windowLabel: 'Tuesday · 5:30–5:45 PM',
      startHour: 17,
      startMinute: 30
    },
    {
      key: 'metrotown-thursday',
      weekday: 4,
      location: 'Metrotown Station',
      windowLabel: 'Thursday · 5:30–5:45 PM',
      startHour: 17,
      startMinute: 30
    }
  ];

  function getPickupRoot() {
    return document.querySelector('[data-pickup-module]');
  }

  function getCartForm(root) {
    return root?.closest('form');
  }

  function getPickupState() {
    if (!window.__hohoPickupState) {
      window.__hohoPickupState = {
        preference: 'Ship',
        slotKey: ''
      };
    }

    return window.__hohoPickupState;
  }

  function setPickupState(nextState) {
    window.__hohoPickupState = {
      ...getPickupState(),
      ...nextState
    };
  }

  function clearPickupState() {
    window.__hohoPickupState = {
      preference: 'Ship',
      slotKey: ''
    };
  }

  function formatYMD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function formatReadableDate(date) {
    return date.toLocaleDateString(undefined, {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  }

  function buildSlotKey(location, dateYmd, windowLabel) {
    return `${location}|${dateYmd}|${windowLabel}`;
  }

  function getCandidateDate(schedule, weekOffset = 0) {
    const now = new Date();
    const candidate = new Date(now);
    const currentDay = candidate.getDay();
    let daysAhead = (schedule.weekday - currentDay + 7) % 7;

    daysAhead += weekOffset * 7;
    candidate.setDate(candidate.getDate() + daysAhead);
    candidate.setHours(schedule.startHour, schedule.startMinute, 0, 0);

    return candidate;
  }

  function getEligibleSlots() {
    const now = new Date();
    const slots = [];

    for (let weekOffset = 0; weekOffset < 8; weekOffset += 1) {
      PICKUP_SCHEDULES.forEach((schedule) => {
        const start = getCandidateDate(schedule, weekOffset);
        const cutoff = new Date(start.getTime() - CUTOFF_HOURS * 60 * 60 * 1000);

        if (now < cutoff) {
          const dateYmd = formatYMD(start);
          const readableDate = formatReadableDate(start);

          slots.push({
            key: buildSlotKey(schedule.location, dateYmd, schedule.windowLabel),
            location: schedule.location,
            dateYmd,
            windowLabel: schedule.windowLabel,
            displayDate: readableDate,
            displayTime: '5:30–5:45 PM',
            summary: `${schedule.location} — ${readableDate} · ${schedule.windowLabel}`,
            start
          });
        }
      });
    }

    slots.sort((a, b) => a.start - b.start);
    return slots.slice(0, MAX_OPTIONS);
  }

  function hydratePickupModule() {
    const root = getPickupRoot();
    if (!root || root.dataset.pickupBound === 'true') return;
    root.dataset.pickupBound = 'true';

    const form = getCartForm(root);
    const radios = Array.from(root.querySelectorAll('[data-pickup-preference]'));
    const panel = root.querySelector('[data-pickup-panel]');
    const slotList = root.querySelector('[data-pickup-slot-list]');
    const unavailable = root.querySelector('[data-pickup-unavailable]');
    const error = root.querySelector('[data-pickup-error]');
    const hiddenSlotKey = root.querySelector('[data-pickup-slot-key]');
    const hiddenLocation = root.querySelector('[data-pickup-location]');
    const hiddenDate = root.querySelector('[data-pickup-date]');
    const hiddenWindow = root.querySelector('[data-pickup-window]');
    const hiddenSummary = root.querySelector('[data-pickup-summary]');

    if (
      !form ||
      !radios.length ||
      !panel ||
      !slotList ||
      !error ||
      !hiddenSlotKey ||
      !hiddenLocation ||
      !hiddenDate ||
      !hiddenWindow ||
      !hiddenSummary
    ) {
      return;
    }

    const eligibleSlots = getEligibleSlots();
    const pageState = getPickupState();
    let closeTimer = null;

    function isPickupSelected() {
      return root.querySelector('[data-pickup-preference]:checked')?.value === 'Local pickup';
    }

    function getSlotButtons() {
      return Array.from(slotList.querySelectorAll('[data-pickup-slot-button]'));
    }

    function setSlotButtonsDisabled(disabled) {
      slotList.classList.toggle('is-disabled', Boolean(disabled));

      getSlotButtons().forEach((button) => {
        button.disabled = Boolean(disabled);
        button.setAttribute('tabindex', disabled ? '-1' : '0');
      });
    }

    function clearSelection() {
      hiddenSlotKey.value = '';
      hiddenLocation.value = '';
      hiddenDate.value = '';
      hiddenWindow.value = '';
      hiddenSummary.value = '';

      getSlotButtons().forEach((button) => {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
      });
    }

    function selectSlot(slot) {
      if (!isPickupSelected()) return;

      hiddenSlotKey.value = slot.key;
      hiddenLocation.value = slot.location;
      hiddenDate.value = slot.dateYmd;
      hiddenWindow.value = slot.windowLabel;
      hiddenSummary.value = slot.summary;

      getSlotButtons().forEach((button) => {
        const isSelected = button.dataset.slotKey === slot.key;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', String(isSelected));
      });

      error.hidden = true;
      setPickupState({
        preference: 'Local pickup',
        slotKey: slot.key
      });
    }

    function finishClosePanel() {
      panel.hidden = true;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    }

    function openPanel() {
      clearTimeout(closeTimer);
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.classList.add('is-open');
        });
      });
    }

    function closePanel() {
      clearTimeout(closeTimer);
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');

      const onTransitionEnd = (event) => {
        if (event.target !== panel) return;
        panel.removeEventListener('transitionend', onTransitionEnd);
        finishClosePanel();
      };

      panel.addEventListener('transitionend', onTransitionEnd);
      closeTimer = window.setTimeout(finishClosePanel, 260);
    }

    function renderSlots() {
      slotList.innerHTML = '';

      if (!eligibleSlots.length) {
        if (unavailable) unavailable.hidden = false;
        return;
      }

      if (unavailable) unavailable.hidden = true;

      eligibleSlots.forEach((slot) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cart-summary__pickup-slot';
        button.dataset.pickupSlotButton = 'true';
        button.dataset.slotKey = slot.key;
        button.setAttribute('aria-pressed', 'false');

        button.innerHTML = `
          <span class="cart-summary__pickup-slot-top">
            <span class="cart-summary__pickup-slot-date">${slot.displayDate}</span>
            <span class="cart-summary__pickup-slot-time">${slot.displayTime}</span>
          </span>
          <span class="cart-summary__pickup-slot-location">${slot.location}</span>
        `;

        button.addEventListener('click', () => {
          if (button.disabled) return;
          selectSlot(slot);
        });

        slotList.appendChild(button);
      });
    }

    function updatePanel() {
      const pickupSelected = isPickupSelected();

      if (pickupSelected) {
        openPanel();
        setSlotButtonsDisabled(!eligibleSlots.length);

        if (!eligibleSlots.length && unavailable) {
          unavailable.hidden = false;
        }

        setPickupState({
          preference: 'Local pickup',
          slotKey: hiddenSlotKey.value || ''
        });
      } else {
        clearSelection();
        setSlotButtonsDisabled(true);
        error.hidden = true;
        closePanel();
        clearPickupState();
      }
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', updatePanel);
    });

    renderSlots();
    setSlotButtonsDisabled(true);
    finishClosePanel();

    const shipRadio = radios.find((radio) => radio.value === 'Ship');
    if (shipRadio) {
      shipRadio.checked = true;
    }

    clearSelection();
    clearPickupState();

    form.addEventListener('submit', (event) => {
      if (!isPickupSelected()) {
        clearSelection();
        clearPickupState();
        return;
      }

      if (!hiddenSlotKey.value) {
        event.preventDefault();
        error.hidden = false;
        const firstSlot = slotList.querySelector('[data-pickup-slot-button]:not(:disabled)');
        if (firstSlot) firstSlot.focus();
        return;
      }

      setPickupState({
        preference: 'Local pickup',
        slotKey: hiddenSlotKey.value
      });
    });
  }

  function initPickupModule() {
    hydratePickupModule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPickupModule, { once: true });
  } else {
    initPickupModule();
  }

  document.addEventListener('cart-page:replaced', () => {
    hydratePickupModule();
  });
})();

(() => {
  function initPickupCheckoutReminder() {
    const cartPage = document.querySelector('.cart-page');
    const form = cartPage?.querySelector('form[action*="/cart"]');
    const modal = document.querySelector('[data-pickup-confirm-modal]');

    if (!cartPage || !form || !modal) return;
    if (modal.dataset.bound === 'true') return;
    modal.dataset.bound = 'true';

    const summaryEl = modal.querySelector('[data-pickup-confirm-summary]');
    const continueButton = modal.querySelector('[data-pickup-confirm-continue]');
    const closeButtons = modal.querySelectorAll('[data-pickup-confirm-close]');
    const checkoutButton = form.querySelector('button[name="checkout"]');
    const pickupRadios = Array.from(document.querySelectorAll('[data-pickup-preference]'));
    const pickupSlotKey = document.querySelector('[data-pickup-slot-key]');
    const pickupDate = document.querySelector('[data-pickup-date]');
    const pickupWindow = document.querySelector('[data-pickup-window]');

    let confirmationAccepted = false;
    let isSubmittingFromModal = false;

    function isPickupSelected() {
      return document.querySelector('[data-pickup-preference]:checked')?.value === 'Local pickup';
    }

    function hasPickupSlot() {
      return Boolean(pickupSlotKey?.value);
    }

    function getPickupSummary() {
      const rawDate = pickupDate?.value;
      const rawWindow = pickupWindow?.value || '';

      let formattedDate = '';
      let formattedTime = rawWindow;

      if (rawDate) {
        const date = new Date(`${rawDate}T12:00:00`);
        if (!Number.isNaN(date.getTime())) {
          formattedDate = date.toLocaleDateString(undefined, {
            weekday: 'short',
            month: 'short',
            day: 'numeric'
          });
        }
      }

      if (rawWindow.includes('·')) {
        const parts = rawWindow.split('·').map((part) => part.trim());
        formattedTime = parts[parts.length - 1] || rawWindow;
      }

      if (formattedDate && formattedTime) {
        return `${formattedDate} · ${formattedTime}`;
      }

      return formattedDate || formattedTime || 'your selected pickup window';
    }

    function openModal() {
      if (summaryEl) {
        summaryEl.textContent = getPickupSummary();
      }

      modal.hidden = false;
      document.body.classList.add('modal-open');

      requestAnimationFrame(() => {
        modal.classList.add('is-open');
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('modal-open');

      window.setTimeout(() => {
        if (!modal.classList.contains('is-open')) {
          modal.hidden = true;
        }
      }, 220);
    }

    function resetConfirmation() {
      confirmationAccepted = false;
    }

    pickupRadios.forEach((radio) => {
      radio.addEventListener('change', resetConfirmation);
    });

    document.addEventListener('click', (event) => {
      const slotButton = event.target.closest('[data-pickup-slot-button]');
      if (slotButton) {
        resetConfirmation();
      }
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        isSubmittingFromModal = false;
        closeModal();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        isSubmittingFromModal = false;
        closeModal();
      }
    });

    if (continueButton) {
      continueButton.addEventListener('click', () => {
        confirmationAccepted = true;
        isSubmittingFromModal = true;
        closeModal();

        if (typeof form.requestSubmit === 'function' && checkoutButton) {
          form.requestSubmit(checkoutButton);
        } else {
          form.submit();
        }
      });
    }

    form.addEventListener('submit', (event) => {
      if (isSubmittingFromModal) {
        isSubmittingFromModal = false;
        return;
      }

      if (!isPickupSelected()) {
        confirmationAccepted = false;
        return;
      }

      if (!hasPickupSlot()) {
        confirmationAccepted = false;
        return;
      }

      if (confirmationAccepted) {
        return;
      }

      event.preventDefault();
      openModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPickupCheckoutReminder, { once: true });
  } else {
    initPickupCheckoutReminder();
  }

  document.addEventListener('cart-page:replaced', () => {
    const modal = document.querySelector('[data-pickup-confirm-modal]');
    if (modal) {
      modal.dataset.bound = 'false';
    }
    initPickupCheckoutReminder();
  });
})();